var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDreamavatarUpload = function SvgIconDreamavatarUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.133 5.414a.666.666 0 0 1-.393-1.207L7.433.794a.66.66 0 0 1 .787 0l4.687 3.413a.67.67 0 0 1-.787 1.08l-3.627-2.64v9.074c0 .366-.3.666-.666.666a.67.67 0 0 1-.667-.666V2.645L3.527 5.287a.66.66 0 0 1-.394.127m-1.13 10.493h11.65a.66.66 0 0 0 .553-.294.66.66 0 0 0 .114-.372v-2.947c0-.367-.3-.667-.667-.667-.366 0-.666.3-.666.667v2.28H2.667v-2.28c0-.367-.3-.667-.667-.667s-.667.3-.667.667v2.947",
    clipRule: "evenodd"
  })));
};
export default SvgIconDreamavatarUpload;